import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { iStoreActions } from '../core/store-actions.interface';
import { Processing } from '../../cmg-1003/models/processing.model';

function createInitialState(): Processing {
  return <Processing>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-1003-processing-store' })
export class Cmg1003ProcessingStore extends Store<Processing> implements iStoreActions<Processing> {
  constructor() {
    super(createInitialState());
  }

  preInitialize(processing: Processing): void {
    // Reset; do not use values from local storage
    this.reset();
    this.update(processing);
  }
}
